import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { Button } from './button/Button.tsx';
import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { Page } from './page/Page.tsx';
import { HistoryViewModel } from '../app/HistoryViewModel.ts';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useState } from 'react';
import { useAsyncEffect } from '../support/hooks/useAsyncEffect.tsx';

export interface Group extends React.FC {
    componentName: string;
};

export const ComponentLibrary: React.FC = () => {
    const history = useInstance(HistoryViewModel);
    const match = useRouteMatch();

    const [groups, setGroups] = useState<Group[]>();

    useAsyncEffect(async () => {
        const modules = import.meta.glob('../**/Demo*.tsx');
        const _groups: Group[] = [];
        for (const path in modules) {
            const component = (await modules[path]() as any).default;
            if (!component.componentName) {
                // derive component name from demo file path
                component.componentName = path.split('/').pop().split('.')[0].substring(4);
            }
            _groups.push(component);
        }
        setGroups(_groups);
    }, []);

    if (!groups) {
        return null;
    }

    return (
        <Page onBack={ history.back} title="Component Library">
            <IonGrid>
                <IonRow>
                    <IonCol size="12" size-md="3" style={{borderRight: '1px solid gray', borderBottom: '1px solid gray'}}>
                        {groups.map(g => (
                            <div key={g.componentName} style={{margin: -10}}>
                                <Button
                                    href={`${match.path}/${g.componentName}`}
                                    color="secondary"
                                    fill="clear"
                                    minWidth={0}
                                >
                                    {g.componentName}
                                </Button>
                            </div>
                        ))}
                    </IonCol>
                    <IonCol size="12" size-md="9" style={{minHeight: '100vw'}}>
                        <div style={{ padding: '0 20px', height: '100%'}}>
                            <Switch>
                                {groups.map(g => {
                                    const url = `${match.path}/${g.componentName}`;
                                    const GroupComponent = g;
                                    return (
                                        <Route path={url} key={g.componentName} exact>
                                            <div style={{height: '100%'}}>
                                                <h1><IonText>{g.componentName}</IonText></h1>
                                                <GroupComponent />
                                            </div>
                                        </Route>
                                    );
                                })};
                                <Route path={match.path}>
                                    <p>Choose a component from the list.</p>
                                </Route>
                            </Switch>
                        </div>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </Page>
    );
};
